export function isPercent(size) {
    return typeof size === 'string' && size.trim().endsWith('%');
}
export function parseSizeToPx(size, containerSize) {
    if (size === undefined || size === null || size === '')
        return undefined;
    if (isPercent(size)) {
        const n = Number.parseFloat(size);
        if (Number.isNaN(n))
            return undefined;
        return (n / 100) * containerSize;
    }
    const n = Number(size);
    return Number.isNaN(n) ? undefined : n;
}
export function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
